import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-up-icon',
  templateUrl: './chevron-up-icon.component.html',
  styleUrl: './chevron-up-icon.component.scss'
})
export class ChevronUpIconComponent {

}
